import React, { useState } from 'react'
import {
  Animation,
  Flex,
  Title,
  Button,
  SelectedItemsContainer,
  TabFooter,
} from 'styling/GlobalStyles'
import { CollapseItemOperationTask } from './CollapseItemOperationTask'
import { Modal } from 'components/Modal/Modal'
import { TaskOperationModal } from 'components/Modal/TaskOperationModal'
import { IOperationGroup } from 'types/operations.interface'
import { ITaskTemplatesTab } from 'types/task-templates.interface'
import { CancelBtn } from 'components/Button/CancelBtn'
import { ItemsPick } from 'components/ItemsPick/ItemsPick'

export const TaskOperationTab = ({ state, setState, handleSubmit }: ITaskTemplatesTab) => {
  const [modal, setModal] = useState({
    isOpen: false,
    operation: null,
  })

  const openModal = (operation: IOperationGroup) => {
    setModal({
      isOpen: true,
      operation,
    })
  }

  const closeModal = () => {
    setModal({
      isOpen: false,
      operation: null,
    })
  }

  const handleAdd = (group: IOperationGroup, operation) => { // TODO provertiti tip
    console.log(operation)
    setState(prev => ({
      ...prev,
      operation: { id: operation.id, name: operation.name },
      operationParameterValues: operation.parameters.map(p => ({
        operationParameter: { name: p.name, id: p.id },
        defaultValue: null
      }))
    }))
    closeModal()
  }
  return (
    <>
      <Animation>
        <Flex between minHeight='600px' gap='2rem'>
          <SelectedItemsContainer>
            <Title fontSize='0.9rem' pad='0 20px'>
              Selected Operation
            </Title>
            {state.operation && (
              <CollapseItemOperationTask
                setState={setState}
                state={state}
                key={state.operation?.id}
              />
            )}
          </SelectedItemsContainer>
          <ItemsPick
            selectedList={[state.operation]}
            handleAdd={openModal}
            link='operation/group/filled'
          />
        </Flex>

        <TabFooter>
          <Flex gap='1rem'>
            <CancelBtn />
            <Button orange onClick={handleSubmit}>
              Save
            </Button>
          </Flex>
        </TabFooter>
      </Animation>
      {modal.isOpen && (
        <Modal black>
          <TaskOperationModal
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            handleAdd={handleAdd}
            closeModal={closeModal}
            operation={modal.operation}
          />
        </Modal>
      )}
    </>

  )
}
